import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ClientService } from 'src/app/private/services/client.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

function atLeastOneSelectedValidator(min = 1) {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const totalSelected = (formArray.value as boolean[]).filter(Boolean).length;
    return totalSelected >= min ? null : { required: true };
  };
}
@Component({
  selector: 'app-add-client',
  imports: [SharedModule],
  templateUrl: './add-client.component.html',
  styleUrl: './add-client.component.scss'
})

export class AddClientComponent {
  @Input() clientId: string = '';
  @Input() type: string = 'Create';
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' }
  ];

  leadChannelsList = ['tina', 'manual', 'whatsapp', 'email'];
  // featureModulesList = [
  //   "dashboard",
  //   "lead",
  //   "event",
  //   "campaign",
  //   "setting",
  //   "email_setting",
  //   "whatsapp_template",
  //   "email_template",
  //   "contact_group",
  //   "user_setting",
  //   "user_log",
  //   "schedule_setting",
  //   "leads_field_setting",
  //   "sales-mail-hub",
  //   "tickets",
  //   "account",
  //   "contacts",
  //   "deals",
  //   "forecast",
  //   "woocommerce"
  // ];

  clientForm = this.fb.group({
    name: ['', Validators.required],
    bot_client_id: [''],
    description: [''],
    logo: [''],
    status: ['', Validators.required],
    total_user: [0, [Validators.required, Validators.min(1)]],
    leadChannels: this.fb.array([], atLeastOneSelectedValidator(1)),
    // feature_modules: this.fb.array([])
  });

  submitted = false;
  isLoading = false;
  initLoading = true;

  constructor(private fb: FormBuilder,
    private api: ClientService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.initLeadChannels();
    // this.initFeatureModules();
  }


  initLeadChannels() {
    const leadChannelsArray = this.clientForm.get('leadChannels') as FormArray;
    this.leadChannelsList.forEach(() => leadChannelsArray.push(this.fb.control(false)));
  }

  // initFeatureModules() {
  //   const featureModulesArray = this.clientForm.get('feature_modules') as FormArray;
  //   this.featureModulesList.forEach(() => featureModulesArray.push(this.fb.control(false)));
  // }


  onCheckboxChange(event: any, controlName: string) {
    const currentValues = this.clientForm.get(controlName)?.value as string[];
    const updatedValues = event.checked
      ? [...currentValues, event.value]
      : currentValues.filter(v => v !== event.value);
    this.clientForm.get(controlName)?.setValue(updatedValues);
  }

  handleAddLeadPipeLine(client_id: any) {
    const now = new Date().toISOString();
    const payload1 = {
      pipeline_name: "Default Lead Pipeline",
      stage_status: "Active",
      "client_id": client_id,
      stages: [
        { stage_name: "New Lead", probability: 10 },
        { stage_name: "Contacted", probability: 20 },
        { stage_name: "Follow-up", probability: 30 },
        { stage_name: "Qualified", probability: 40 },
        { stage_name: "Marketing Qualified Lead (MQL)", probability: 50 },
        { stage_name: "Sales Qualified Lead (SQL)", probability: 60 },
        { stage_name: "Proposal / Negotiation", probability: 75 },
        { stage_name: "Closed - Won", probability: 100 },
        { stage_name: "Closed - Lost", probability: 0 },
        { stage_name: "Disqualified", probability: 0 },
        { stage_name: "Duplicate", probability: 0 },
        { stage_name: "Not Interested", probability: 0 }
      ],
      set_default: null,
      pipeline_type: "lead",
      createdAt: now,
      updatedAt: now
    };
    this.api.createPipeLine(payload1).subscribe({
      next: (data) => {
        console.log('Pipeline created:', data);
      },
      error: (err) => console.error('Pipeline creation failed', err)
    });
  }

  handleAddDealPipeLine(client_id: any) {
    const now = new Date().toISOString();
    const payload = {
      pipeline_name: "Demo Pipeline 2",
      stage_status: "Active",
      client_id: client_id,
      stages: [
        { stage_name: "Qualification / Needs Analysis", probability: 10 },
        { stage_name: "Value Analysis", probability: 25 },
        { stage_name: "Proposition / Solution Fit", probability: 40 },
        { stage_name: "Identify Decision Makers", probability: 50 },
        { stage_name: "Proposal / Price Quote", probability: 60 },
        { stage_name: "Negotiation / Review", probability: 75 },
        { stage_name: "Closed - Won", probability: 100 },
        { stage_name: "Closed - Lost", probability: 0 },
        { stage_name: "Closed - Lost to Competition", probability: 0 }
      ],
      set_default: false,
      pipeline_type: "deal",
      createdAt: now,
      updatedAt: now
    }
    this.api.createPipeLine(payload).subscribe({
      next: () => console.log(`Deal pipeline created`),
      error: (err) => console.error(`Deal pipeline failed`)
    });

  }
  submitForm() {
    this.submitted = true;
    if (this.clientForm.invalid) return;

    const leadChannelsNames = this.leadChannelsList.filter((_, index) => this.clientForm.get('leadChannels')?.value[index]);
    // const featureModulesNames = this.featureModulesList.filter((_, index) => this.clientForm.get('feature_modules')?.value[index]);

    const payload = {
      ...this.clientForm.value,
      leadChannels: leadChannelsNames,
      // feature_modules: featureModulesNames
    }

    this.isLoading = true;
    this.api.createClient(payload).subscribe({
      next: (data) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Client created successfully'
        });
        this.handleAddDealPipeLine(data.client_id);
        this.handleAddLeadPipeLine(data.client_id);
        this.reload.emit();
        this.close.emit();
        const clientId = data?.id;
        // this.api.getClient({ "client_id": this.clientId }).subscribe({
        //   next: (clientData) => {
        //   // Use this clientData if needed
        //   },
        //   error: (err) => console.error('Failed to fetch client', err)
        // });
        // const clientId = data?.id || data?.clientId;


        // deal pipeline





      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to create client'
        });
        this.isLoading = false;
      }
    });


  }

  handleCloseDialog() {
    this.close.emit();
  }
}
